/** This file is auto generated by convertSvgToJsx.ts */

import React from 'react'
import type { IconSVGProps } from '../../components/icon/Icon'
const cloud_sync = (props) => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    width={16}
    height={16}
    fill="none"
    viewBox="0 0 16 16"
    {...props}
  >
    <g clipPath="url(#cloud_sync_svg__a)">
      <path
        fill="#000"
        d="m3.617 4.918.14.737-.14-.737Zm1.837 1.026a.75.75 0 1 0 .747-1.3l-.747 1.3ZM7.72 10.26a.75.75 0 0 0 1.416.494L7.72 10.26Zm7.091.394-.708.247.176.503h.532v-.75Zm.709 2.325a.75.75 0 0 0-1.417-.493l1.417.493Zm-7.092-.394.708-.247-.175-.503h-.533v.75Zm6.57-1.93v.75a.75.75 0 0 0 .75-.75H15Zm.75-2.093a.75.75 0 1 0-1.5 0h1.5Zm-2.841 1.342a.75.75 0 0 0 0 1.5v-1.5Zm-2.575 3.431a.75.75 0 0 0 0-1.5v1.5Zm-2.092-.75v-.75a.75.75 0 0 0-.75.75h.75Zm-.75 2.092a.75.75 0 0 0 1.5 0h-1.5Zm4.323-9.592a.75.75 0 1 0 1.489-.182l-1.489.182Zm-6.566 6.963a.75.75 0 0 0 0-1.5v1.5Zm-1.03-1.5A2.468 2.468 0 0 1 1.75 8.08H.25a3.968 3.968 0 0 0 3.968 3.969v-1.5ZM1.75 8.08a2.47 2.47 0 0 1 2.007-2.425l-.279-1.474a3.97 3.97 0 0 0-3.228 3.9h1.5Zm2.613-3.077c.229-2 2.018-3.253 3.717-3.253V.25c-2.338 0-4.879 1.708-5.208 4.583l1.49.17Zm-.606.652a2.501 2.501 0 0 1 1.697.289l.747-1.3a4.001 4.001 0 0 0-2.723-.463l.279 1.474Zm5.38 5.1a2.63 2.63 0 0 1 2.484-1.764v-1.5a4.13 4.13 0 0 0-3.9 2.77l1.416.494Zm2.484-1.764c1.098 0 2.107.833 2.483 1.911l1.417-.494c-.545-1.56-2.046-2.917-3.9-2.917v1.5Zm2.483 3.496a2.63 2.63 0 0 1-2.483 1.763v1.5a4.13 4.13 0 0 0 3.9-2.77l-1.417-.493Zm-2.483 1.763c-1.098 0-2.108-.832-2.484-1.91l-1.416.493c.544 1.56 2.045 2.917 3.9 2.917v-1.5Zm4.129-3.595V8.563h-1.5v2.092h1.5Zm-.75-.75h-2.092v1.5H15v-1.5Zm-4.667 1.931H8.241v1.5h2.092v-1.5Zm-2.842.75v2.092h1.5v-2.092h-1.5Zm7.321-1.18H15v-1.5h-.188v1.5Zm-6.383.43H8.24v1.5h.188v-1.5ZM8.08 1.75c2.097 0 3.52 1.585 3.734 3.336l1.489-.182C13.01 2.508 11.037.25 8.08.25v1.5ZM4.218 12.049h1.03v-1.5h-1.03v1.5Z"
      />
    </g>
    <defs>
      <clipPath id="cloud_sync_svg__a">
        <path fill="#fff" d="M0 0h16v16H0z" />
      </clipPath>
    </defs>
  </svg>
)
export default cloud_sync
